import { useState } from 'react'
import { Button } from '@mui/material'
import PrintIcon from '@mui/icons-material/Print'

// Shared trigger for the branded PDF print-outs. `onPrint` is an async
// handler that builds and downloads the document (usually via downloadPdf);
// the button disables itself while that runs so a slow render can't be
// double-fired.
const PrintButton = ({ onPrint, label = 'Print', disabled, ...buttonProps }) => {
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    setLoading(true)
    try {
      await onPrint()
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      size="small"
      startIcon={<PrintIcon />}
      {...buttonProps}
      disabled={loading || disabled}
      onClick={handleClick}
    >
      {loading ? 'Preparing PDF…' : label}
    </Button>
  )
}

export default PrintButton
